var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDarEmpEmailMobile = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 13,
  viewBox: "0 0 16 13",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M14.75 0.875H1.25C1.10082 0.875 0.957742 0.934263 0.852252 1.03975C0.746763 1.14524 0.6875 1.28832 0.6875 1.4375V11C0.6875 11.2984 0.806026 11.5845 1.017 11.7955C1.22798 12.0065 1.51413 12.125 1.8125 12.125H14.1875C14.4859 12.125 14.772 12.0065 14.983 11.7955C15.194 11.5845 15.3125 11.2984 15.3125 11V1.4375C15.3125 1.28832 15.2532 1.14524 15.1477 1.03975C15.0423 0.934263 14.8992 0.875 14.75 0.875ZM13.3037 2L8 6.86211L2.69633 2H13.3037ZM14.1875 11H1.8125V2.71648L7.61961 8.03984C7.72339 8.13511 7.85913 8.18797 8 8.18797C8.14087 8.18797 8.27661 8.13511 8.38039 8.03984L14.1875 2.71648V11Z",
  fill: "#7A757F"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgDarEmpEmailMobile);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/dar_emp_email_mobile.134e4cf15667d7facf79af87777554c0.svg";